var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8756 14.625C34.8756 18.9742 31.3498 22.5 27.0006 22.5C22.6513 22.5 19.1256 18.9742 19.1256 14.625C19.1256 10.2758 22.6513 6.75 27.0006 6.75C31.3498 6.75 34.8756 10.2758 34.8756 14.625Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0006 29.25C19.3705 29.25 13.5815 33.7823 11.2111 40.1915C10.2913 42.6785 12.4168 45 15.0684 45H38.9327C41.5843 45 43.7098 42.6785 42.79 40.1915C40.4196 33.7823 34.6307 29.25 27.0006 29.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4afea6ec83d9ae7ceb522c08f140ec22.svg";
export { ForwardRef as ReactComponent };